import { ANY, BLOG_LISTING, BLOG_POST, LANDING_PAGE, SITE_PAGE } from 'ContentUtils/constants/ModuleContentTypes';
export const ModuleContentType = {
  ANY,
  BLOG_LISTING,
  BLOG_POST,
  LANDING_PAGE,
  SITE_PAGE
};
export const MODULE_CONTENT_TYPE_ORDER = [ANY, BLOG_LISTING, BLOG_POST, LANDING_PAGE, SITE_PAGE];
export const MODULE_CONTENT_TYPE_VALUES = Object.values(ModuleContentType);